module.exports = __webpack_public_path__ + "static/img/honor-10.80686d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/honor-10.png
// module id = cYFW
// module chunks = 0